export const Form = 'Form';
export const Type = 'Type';

export const defaultForm = ["Agency", "BDC"]
export const defaultType = ["Sales", "Rentals"]
